const REFERENCE_DISPLAY_LENGTH = 8;

export function formatRecordReference(reference: string | undefined | null): string {
  if (reference == null || reference === '') {
    return '';
  }
  if (reference.length <= REFERENCE_DISPLAY_LENGTH) {
    return reference;
  }
  return reference.slice(-REFERENCE_DISPLAY_LENGTH);
}
